/**
 * Builds an as-hovercard-wrapper or as-tooltip-wrapper element configured for
 * show-on-hover, stretched to fill its container so hovering anywhere over the
 * row (not just the label text) triggers the popup. The caller is responsible
 * for appending its content (and, for the hovercard case, the as-hovercard
 * element itself) and inserting the wrapper into the DOM.
 *
 * Shared between as-option (wraps its own slotted content) and as-dropdown
 * (rebuilds the same wrapping around its portaled option clones, since the
 * real as-option elements stay hidden in the closed-shut slot).
 */
export function createOptionHoverWrapper(
  tooltipDefaultText: string | null,
  tooltipDictKey: string | null,
  hasHovercard: boolean
): HTMLElement {
  const wrapper = document.createElement(hasHovercard ? 'as-hovercard-wrapper' : 'as-tooltip-wrapper');
  wrapper.toggleAttribute('show-on-hover', true);
  wrapper.setAttribute('placement', 'right');
  wrapper.style.display = 'flex';
  wrapper.style.flexDirection = 'row';
  wrapper.style.width = '100%';

  if (!hasHovercard) {
    if (tooltipDefaultText) wrapper.setAttribute('default-text', tooltipDefaultText);
    if (tooltipDictKey) wrapper.setAttribute('dict-key', tooltipDictKey);
  }

  return wrapper;
}
